import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const ShareActions = ({ postTitle, postUrl }) => {
  const [copied, setCopied] = useState(false);

  const handleCopyLink = async () => {
    try {
      await navigator.clipboard?.writeText(postUrl);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch (err) {
      console.error('Failed to copy:', err);
    }
  };

  const shareOptions = [
    {
      name: 'Twitter',
      icon: 'Twitter',
      url: `https://twitter.com/intent/tweet?text=${encodeURIComponent(postTitle)}&url=${encodeURIComponent(postUrl)}`,
      color: 'var(--color-primary)'
    },
    {
      name: 'LinkedIn',
      icon: 'Linkedin',
      url: `https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(postUrl)}`,
      color: 'var(--color-secondary)'
    },
    {
      name: 'Facebook',
      icon: 'Facebook',
      url: `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(postUrl)}`,
      color: 'var(--color-accent)'
    }
  ];

  return (
    <div className="border-t border-border pt-6 md:pt-8 lg:pt-10 mt-8 md:mt-10 lg:mt-12">
      <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4 md:gap-6">
        <h3 className="text-base md:text-lg font-medium text-foreground">
          Share this article
        </h3>
        
        <div className="flex flex-wrap items-center gap-3 md:gap-4">
          {shareOptions?.map((option) => (
            <a
              key={option?.name}
              href={option?.url}
              target="_blank"
              rel="noopener noreferrer"
              className="w-10 h-10 md:w-12 md:h-12 rounded-lg bg-card border border-border flex items-center justify-center transition-all duration-250 hover:bg-muted hover:scale-105"
              aria-label={`Share on ${option?.name}`}
            >
              <Icon name={option?.icon} size={18} color={option?.color} />
            </a>
          ))}
          
          <Button
            variant="outline"
            size="default"
            onClick={handleCopyLink}
            iconName={copied ? 'Check' : 'Link'}
            iconPosition="left"
            className="min-w-[120px]"
          >
            {copied ? 'Copied!' : 'Copy Link'}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default ShareActions;